module.exports = __webpack_public_path__ + "assets/metrics-star.ff0be571.svg";